import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class PhoneVerificationComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/phone-verification';
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/phone-verification((\/?#?)|(\/?#.*?))$/;
  }
}
